import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate product image
export const generateOutline =
    (uploaded_image_object, style, colorOne, colorTwo, backgroundColor) =>
    async (dispatch) => {
        await axios
            .post(`/api/outlines/generate_outline`, {
                uploaded_image: uploaded_image_object,
                style: style,
                colorOne: colorOne,
                colorTwo: colorTwo,
                backgroundColor: backgroundColor,
            })
            .then(async (response) => {
                dispatch({
                    type: "GENERATE_OUTLINE_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Download product image
export const downloadOutline =
    (outline_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/outlines/download/${outline_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch seamless products of a user
export const fetchUserOutlines =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(`/api/outlines/user_outlines/${key}/${offset}/${limit}`)
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_OUTLINES_SUCCESS",
                    payload: response.data,
                    key: "user_outlines" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
